import { VariantResult } from "@relewise/client";
import { adjustUrl } from "@danishagro/shared/src/helpers/adjustUrl.helper";

export const getDiscountedVariantUrl = (
    variantDiscounts: string[] | undefined,
    canonicalBaseUrl: string | undefined,
    allVariants: VariantResult[] | undefined | null
): string | null => {
    const variantId = variantDiscounts?.[0];
    if (!variantId) return null;

    const baseUrl = canonicalBaseUrl;
    if (!baseUrl) return null;

    const slug = allVariants?.find((v) => v.variantId === variantId)?.data?.webNameSlug?.value;

    return slug ? adjustUrl(`${baseUrl}/${slug}`) : null;
};
